<template>
  <div id="findGamepass">
    <div class="thead">Поиск gamepass по нику игрока</div>
    <div class="df fc wa">
      <div class="sector bg-darker wa">
        <div class="t-light fs30">Введите ваш ник в игре</div>
        <input type="text" class="wa" placeholder="nickname" v-model="nickname" />
      </div>
      <button class="fs24 wa" @click="loadGames">Найти игрока</button>
    </div>
    <div class="df fc wa">
      <div class="sector bg-darker wa" v-if="games">
        <div class="t-light fs30">Выберите режим</div>
        <div class="df fr wa list green">
          <button class="item" v-for="game, index in games" :key="index" @click="loadPasses(game.id)">{{ game.name }}</button>
        </div>
      </div> 
    </div>
    <div class="df fc wa">
      <div class="sector bg-darker wa" v-if="games && passes">
        <div class="t-light fs30">Выберите gamepass</div>
        <div class="df fr wa list blue">
          <button class="item" v-for="pass, index in passes" :key="index" @click="select(pass)">{{ pass.name }}</button>
		</div>
		<div class="df fr wa" v-if="gameid && passes">
      	  <button class="fs24 wa" @click="openCreateInstructions" v-if="passes.length === 0 || data.amount">Создать gamepass</button>
      	</div>
      </div>
      <button class="wa fs24 red" @click="goBack">Назад</button>
	</div>
  </div>
</template>

<script>
import { GetUserGamesRequest, GetGamepassesRequest } from "@/protos/user_pb.js";
import Utils from "@/utils.js"

export default {
  props: ["data"],

  data() {
	return {
	  nickname: "",
	  games: null,
	  passes: null,
	  gameid: null,
    universe: null
	}
  },

  methods: {
	select(pass) {
	  if (this.data.amount)
		this.$root.startBuildingOrder({ gamepassesIds: [pass.id], amount: this.data.amount, email: this.data.email, promo: this.data.promo, bonus: this.data.bonus })
	  else {
		const url = `https://web.roblox.com/game-pass/${pass.id}/`
		this.$root.setState({ label: "buy-one", data: { gamepass: url, amount: Utils.takeCommision(pass.price), email: this.data.email, promo: this.data.promo, bonus: this.data.bonus }})
	  }  
	},

	goBack() {
	  this.$root.setState({ label: "buy-one", data: this.data })
	},

	openCreateInstructions() {
	  this.$root.setState({ label: "create-gamepass", data: { ...this.data, universe: this.universe, game: this.gameid } })
	},

	loadGames() {
	  this.games = null
	  this.passes = null
	  this.gameid = null
	  if (this.nickname.length > 25 || this.nickname.length < 3)
		return

	  const r = new GetUserGamesRequest()
	  r.setNickname(this.nickname.trim())
	  this.$root.client.getUserGames(r, null, (err, resp) => {
		this.games = []
		for (const game of resp.getGamesList())
		  this.games.push({
			id: game.getId(),
			name: game.getName()
		  })
	  })
	},

	loadPasses(game) {
	  this.gameid = game
	  const r = new GetGamepassesRequest()
	  r.setGame(game)
	  this.$root.client.getGamepasses(r, null, (err, resp) => {
		this.passes = []
		for (const gp of resp.getGamepassesList())
		  this.passes.push({
			id: gp.getId(),
			name: gp.getName(),
			price: gp.getPrice()
		  })
    this.universe = resp.getUniverse()
	  })
	}
  }
}
</script>

<style scoped lang="scss">
.list {
  flex-flow: row wrap;

  &.green > * {
    background: rgba(6, 119, 38, 0.1);
    color: #05FF00;

    &:hover {
      background: rgba(6, 119, 38, 0.3);
    }

    &:active {
      background: rgba(6, 119, 38, 0.5);
    }

    &.active {
      background: rgba(6, 119, 38, 0.8);
    }
  }

  &.blue > * {
    background: rgba(9, 6, 119, 0.1);
    color: #AA95FF;

    &:hover {
      background: rgba(9, 6, 119, 0.3);
    }

    &:active {
      background: rgba(9, 6, 119, 0.5);
    }

    &.active {
      background: rgba(9, 6, 119, 0.8);
    }
  }
}

.item {
  padding: 10px 40px;
  font-size: 24px;
  flex: 1;

  &:hover {
    transition: 0.1s linear;
  }
  &:active {
    transition: 0.3s linear;
  }
}
</style>
